import { render, staticRenderFns } from "./InboxSharedThread.vue?vue&type=template&id=4cca8349&scoped=true&"
import script from "./InboxSharedThread.vue?vue&type=script&lang=js&"
export * from "./InboxSharedThread.vue?vue&type=script&lang=js&"
import style0 from "./InboxSharedThread.vue?vue&type=style&index=0&id=4cca8349&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cca8349",
  null
  
)

export default component.exports